import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logoImage from '@assets/images/logo_L.png'
import ChangePasswordForm from './components/ChangePasswordForm'
import { LoadingOverlay } from '@/components/LoadingOverlay'
import Footer from '@components/Footer'
import { useAuth } from '@/context/AuthContext'
import { useAdminAccount } from '@/context/AdminAccountContext'

function FirstLogin() {
  const navigate = useNavigate()
  const { user, loading: authLoading } = useAuth()
  const { adminAccount, isLoading: adminAccountLoading } = useAdminAccount()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (authLoading || adminAccountLoading) return
    if (!user) {
      navigate('/login', { replace: true })
      return
    }
    if (adminAccount && adminAccount.lastLoginAt) {
      navigate('/dashboards', { replace: true })
    }
  }, [user, adminAccount, authLoading, adminAccountLoading, navigate])

  if (authLoading || adminAccountLoading) {
    return <LoadingOverlay show />
  }

  if (!user || (adminAccount && adminAccount.lastLoginAt)) {
    return null
  }

  return (
    <div className="auth-page-shell">
      <div className="login-container">
        <LoadingOverlay show={isLoading} />
        <div className="login-card">
          <img src={logoImage} alt="IROGAMI" className="login-logo" />
          <h2 className="change-password-title">
            初回ログインのため、<br></br>パスワードを変更してください。
          </h2>
          <ChangePasswordForm onLoadingChange={setIsLoading} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default FirstLogin
